import React, { useState, useEffect } from 'react';
import ImageV2 from 'components_v2/common/ImageV2';
import Links from 'components/Link';
import NewsletterSubscriptionPopup from './NewsletterSubscriptionPopup';
import NewsletterEmailPopup from './NewsletterEmailPopup';
import Morebtn from '../../../components_v2/desktop/Morebtn';
import s from './NewsletterCard.scss';

const NewsletterCard = props => {
  const {
    msid,
    heading,
    description,
    customOptions,
    isSubscribed,
    userPreference,
    onSubscribe,
    serviceId,
    id,
    hideEdit,
    isListingPage,
    imagemsid,
    logowidth,
    logoheight,
  } = props;

  const [isEditing, setIsEditing] = useState(false);
  const [showPreferencesMessage, setShowPreferencesMessage] = useState(false);
  const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false);
  const [selectedFrequency, setSelectedFrequency] = useState(
    (userPreference && userPreference.periodicalFrequency) || null,
  );
  const [userEmail, setUserEmail] = useState('');
  const [showemailerrmsg, setShowemailerrmsg] = useState(false);
  const [selectedDay, setSelectedDay] = useState(
    (userPreference && userPreference.dayOfWeek) || null,
  );
  const [selectedTime, setSelectedTime] = useState(
    (userPreference && userPreference.dayScheduleSlot) || null,
  );
  const [userPreferenceState, setUserPreferenceState] = useState(
    userPreference,
  );
  const [lastSavedPreference, setLastSavedPreference] = useState(
    userPreference,
  );
  const [showPromptPopup, setShowPromptPopup] = useState(false);

  useEffect(
    () => {
      if (userPreference) {
        setUserPreferenceState(userPreference);
        setSelectedFrequency(userPreference.periodicalFrequency || null);
        setSelectedDay(userPreference.dayOfWeek || null);
        setSelectedTime(userPreference.dayScheduleSlot || null);
      }
    },
    [userPreference],
  );

  const hasPreferencesChanged = () => {
    if (!lastSavedPreference || !userPreferenceState) return false;
    return (
      lastSavedPreference.periodicalFrequency !==
        userPreferenceState.periodicalFrequency ||
      lastSavedPreference.dayOfWeek !== userPreferenceState.dayOfWeek ||
      lastSavedPreference.dayScheduleSlot !==
        userPreferenceState.dayScheduleSlot
    );
  };

  useEffect(
    () => {
      if (
        selectedFrequency &&
        userPreferenceState &&
        userPreferenceState.periodicalFrequency !== selectedFrequency
      ) {
        setUserPreferenceState(prevState => ({
          ...prevState,
          periodicalFrequency: selectedFrequency,
          dayOfWeek: selectedFrequency === 'WEEKLY' ? selectedDay : undefined,
        }));
      }
      if (
        selectedDay &&
        userPreferenceState &&
        userPreferenceState.dayOfWeek !== selectedDay
      ) {
        setUserPreferenceState(prevState => ({
          ...prevState,
          dayOfWeek: selectedDay,
        }));
      }
      if (
        selectedTime &&
        userPreferenceState &&
        userPreferenceState.dayScheduleSlot !== selectedTime
      ) {
        setUserPreferenceState(prevState => ({
          ...prevState,
          dayScheduleSlot: selectedTime,
        }));
      }
    },
    [selectedFrequency, selectedDay, selectedTime],
  );

  const customOptionsKeys = Object.keys(
    typeof customOptions === 'object' ? customOptions : {},
  );

  const subscribeCallback = () => {
    setShowSubscriptionPopup(isSubscribed ? 'Unsubscribe' : 'Subscribe');
    if (!isListingPage) {
      setTimeout(() => {
        setShowSubscriptionPopup(false);
      }, 5000);
    }
  };

  const editingCallback = () => {
    setLastSavedPreference(userPreferenceState);
    setShowPreferencesMessage(true);
    setTimeout(() => {
      setIsEditing(false);
      setShowPreferencesMessage(false);
    }, 3000);
  };

  const getValidEmailId = email => {
    const regEmail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,6})$/;
    let emailId = '';
    if (regEmail.test(email)) {
      emailId = email;
    }

    return emailId;
  };
  const handleEmailIdChange = e => {
    const { value } = e.target;
    setUserEmail(value);
  };

  return (
    <>
      <div
        className={`${s.Newscard} ${isListingPage ? s.newsletterCard : ''} ${
          (showSubscriptionPopup || isSubscribed) && isListingPage
            ? s.subscriptionResultWrap
            : ''
        }`}
      >
        <div className={s.NewsletterCardContent}>
          <div className={s.imageWrap}>
            <div className={s.content}>
              {isListingPage && (
                <Links to="/newsletters">
                  <ImageV2 msid={msid} width="360" isInlineImage />
                </Links>
              )}
              {!isListingPage && (
                <ImageV2 msid={msid} width="360" isInlineImage />
              )}
            </div>
          </div>
          <div className={s.headingWrap}>
            <h3 className={s.headingText}>{heading}</h3>

            {description && <p className={s.descriptionText}>{description}</p>}
          </div>
        </div>
        {((isListingPage && !showSubscriptionPopup && !isSubscribed) ||
          !isListingPage) && (
          <div className={s.contentWrap}>
            {!isListingPage &&
              Array.isArray(customOptionsKeys) &&
              customOptionsKeys.length > 0 &&
              customOptionsKeys.map(key => {
                let iconClass = '';
                if (key === 'frequency') {
                  iconClass = s.calender;
                } else if (key === 'time') {
                  iconClass = s.timer;
                }
                let optionState = null;
                let dropdownState = null;

                let optionStateHandler = () => {};
                let dropdownStateHandler = () => {};
                if (key === 'frequency') {
                  optionState = selectedFrequency;
                  optionStateHandler = setSelectedFrequency;
                  dropdownState = selectedDay;
                  dropdownStateHandler = setSelectedDay;
                } else if (key === 'time') {
                  optionState = selectedTime;
                  optionStateHandler = setSelectedTime;
                }
                return (
                  <div className={s.dd_filter}>
                    <i className={iconClass} /> {key}:{' '}
                    {customOptions[key].map(option => {
                      if (!option.label) return null;

                      if (option.type === 'radio') {
                        return (
                          <div
                            className={`${s.custom_radio_cont} ${
                              s.custom_input_box
                            }`}
                          >
                            <span
                              className={`${s.custom_radio} ${
                                optionState === option.value ? s.selected : ''
                              } ${
                                isSubscribed && !isEditing ? s.disabled : ''
                              }`}
                            >
                              <input
                                checked={optionState === option.value}
                                value={option.value}
                                name={key}
                                type="radio"
                                onChange={event =>
                                  optionStateHandler(event.target.value)
                                }
                                id={`${key}-${option.value}`}
                                disabled={isSubscribed && !isEditing}
                              />
                              <label htmlFor={`${key}-${option.value}`}>
                                {option.label}
                              </label>
                            </span>
                          </div>
                        );
                      }

                      if (
                        option.type === 'dropdown' &&
                        Array.isArray(option.dropdownOptions) &&
                        option.dropdownOptions.length > 0
                      ) {
                        return (
                          <div
                            className={`${s.custom_dropdown} ${
                              s.custom_input_box
                            }`}
                          >
                            <select
                              className={`${s.select} ${
                                optionState === option.value ? s.selected : ''
                              } ${
                                isSubscribed && !isEditing ? s.disabled : ''
                              }`}
                              onChange={event => {
                                optionStateHandler(option.value);
                                dropdownStateHandler(event.target.value);
                              }}
                              onClick={event => {
                                if (optionState !== option.value) {
                                  optionStateHandler(option.value);
                                  dropdownStateHandler(event.target.value);
                                }
                              }}
                              id={`${key}-${option.value}`}
                              disabled={isSubscribed && !isEditing}
                            >
                              {option.dropdownOptions.map(opt => (
                                <option
                                  value={opt.value}
                                  selected={dropdownState === opt.value}
                                  id={`${key}-${option.value}-${opt.value}`}
                                >
                                  {opt.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        );
                      }
                      return (
                        <span className={s.no_option} key={option.label}>
                          {option.label}
                        </span>
                      );
                    })}
                  </div>
                );
              })}

            {isListingPage &&
              !isSubscribed && (
                <form className={s.formWrap} autoComplete="off">
                  <div className={s.emailInput}>
                    <input
                      autoComplete="off"
                      type="text"
                      name="emailId"
                      placeholder="Enter Email"
                      maxLength="100"
                      value={userEmail}
                      onChange={e => handleEmailIdChange(e)}
                    />
                    <label htmlFor="emailId">Email</label>
                    {showemailerrmsg && (
                      <span className={s.errorMsg}>
                        Please enter a valid email address
                      </span>
                    )}
                  </div>
                </form>
              )}
            {((isListingPage && !isSubscribed) || !isListingPage) && (
              <div className={s.btnWrap}>
                {!isEditing &&
                  !showPreferencesMessage && (
                    <>
                      <Morebtn
                        onClick={() => {
                          if (typeof onSubscribe === 'function') {
                            if (!isListingPage) {
                              onSubscribe(
                                serviceId,
                                userPreferenceState,
                                subscribeCallback,
                                isSubscribed,
                                isListingPage ? userEmail : null,
                              );
                            } else if (isListingPage) {
                              if (getValidEmailId(userEmail).length > 0) {
                                setShowemailerrmsg(false);
                                onSubscribe(
                                  serviceId,
                                  userPreferenceState,
                                  subscribeCallback,
                                  isSubscribed,
                                  isListingPage ? userEmail : null,
                                );
                              } else {
                                setShowemailerrmsg(true);
                              }
                            }
                          }
                        }}
                        moreText={isSubscribed ? 'Unsubscribe' : 'Subscribe'}
                        redBrdr
                        noArrow
                      />

                      {isSubscribed &&
                        !hideEdit && (
                          <button
                            className={s.edit_btn}
                            onClick={() => setIsEditing(true)}
                          >
                            <i />
                          </button>
                        )}
                    </>
                  )}

                {isEditing &&
                  !showPreferencesMessage && (
                    <>
                      <Morebtn
                        onClick={() => setIsEditing(false)}
                        redBrdr
                        moreText="Close"
                        noArrow
                      />
                      <Morebtn
                        onClick={() => {
                          if (typeof onSubscribe === 'function') {
                            onSubscribe(
                              serviceId,
                              userPreferenceState,
                              editingCallback,
                              false,
                            );
                          }
                        }}
                        redbg
                        noArrow
                        moreText="Save Changes"
                        disabled={!hasPreferencesChanged()}
                      />
                    </>
                  )}
                {!isListingPage && (
                  <>
                    <Morebtn
                      onClick={() => setShowPromptPopup(true)}
                      redBrdr
                      moreText="Preview"
                      noArrow
                    />
                  </>
                )}
                {showPreferencesMessage && (
                  <p className={s.successMsg}>
                    <i /> Your preferences have been updated!
                  </p>
                )}
              </div>
            )}
          </div>
        )}
        {((showSubscriptionPopup === 'Subscribe' && isListingPage) ||
          (isListingPage && isSubscribed)) && (
          <div className={s.subscriptionResult}>
            <h3>
              {' '}
              <i className={s.tick} /> Thank you for subscribing!
            </h3>
            <p>
              Welcome to The TOI family!Look out for your newsletter in your
              inbox
            </p>
          </div>
        )}
        {showSubscriptionPopup === 'Unsubscribe' &&
          isListingPage && (
            <div className={s.subscriptionResult}>
              <h3>
                We&apos;re sorry to see you go! <i />
              </h3>
              <p>
                Thank you for being part of the {heading}. If you ever want to
                rejoin, just know we&apos;ll be here with fresh updates and
                content.
              </p>
            </div>
          )}
      </div>
      {!isListingPage &&
        showSubscriptionPopup && (
          <NewsletterSubscriptionPopup
            {...props}
            isUnsubscribeMessage={showSubscriptionPopup === 'Unsubscribe'}
            onCloseCallback={() => setShowSubscriptionPopup(false)}
            id={id}
          />
        )}
      {showPromptPopup && (
        <NewsletterEmailPopup
          {...props}
          onCloseCallback={() => setShowPromptPopup(false)}
          id={id}
          onSubscribe={onSubscribe}
          subscribeCallback={subscribeCallback}
          isSubscribed={isSubscribed}
          userPreference={userPreferenceState}
          serviceId={serviceId}
        />
      )}
    </>
  );
};

export default NewsletterCard;
